import { IgButton } from "@intelligems/ig-theme";
import {
  ExperienceBuilderAiAction,
  ExperienceBuilderAiSelector,
} from "@src/store/slices/experienceBuilder/ai";
import { useDispatch, useSelector } from "@src/store";

export const AiAssistantButton = () => {
  const dispatch = useDispatch();
  const isAiChatOpen = useSelector(ExperienceBuilderAiSelector.isOpen);
  if (isAiChatOpen) return null;

  const onClick = () => dispatch(ExperienceBuilderAiAction.setOpen(true));

  return (
    <IgButton
      sx={{ height: "32px" }}
      size="small"
      variant="ai"
      onClick={onClick}
    >
      AI Assistant
    </IgButton>
  );
};
